export const insertOrderPrimarySelector = (state) =>
  state.insertOrderPrimary.active;
